
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.LateGps = {

  template() {
    return {
      tag: 'div',
      items: [
        {
          items: [
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  html: Monet.I18n.getResourcesByKey('event.lategps.timeinterval'),
                  attributes: {
                    class: 'i18nResource',
                  },
                },
              ],
              attributes: {
                class: 'control-label',
                for: 'late_gps_timeIntervalMinutes',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    'type': 'text',
                    'name': 'late_gps_timeIntervalMinutes',
                    maxlength: '10',
                    'alt': '',
                    value: '',
                    size: '11',
                    'id': 'late_gps_timeIntervalMinutes',
                    'class': 'modelAttribute textField numberPicker mandatory',
                    autocomplete: 'off',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
          ],
          attributes: {
            class: 'control-group',
          },
        },
      ],
    };
  },

  assignParameter(jsonParam) {
    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);

      $('#late_gps_timeIntervalMinutes').val(jsonParam.timeIntervalMinutes);
    }
  },
  retrieveParameter() {
    const timeMinutes = parseInt($('#late_gps_timeIntervalMinutes').val(), 10);

    return JSON.stringify({
      timeIntervalMinutes: timeMinutes,
    });
  },

};
